(() => {
  const targetClass = 'slp_13efdb';
  const searchPattern = /\bPoints\b/g;
  const replacementText = 'نقطة';

  const isRtl = () => document.documentElement.getAttribute('dir') === 'rtl';

  const earnWithCash = /Earn\s+([\d,]+)\s+(?:Cash\s+)?(?:Points|نقطة)\s+when\s+you\s+buy\s+this\s+(?:item|product)\.?/i;
  const earnPlain = /Earn\s+([\d,]+)\s+when\s+you\s+buy\s+this\s+(?:item|product)\.?/i;
  const logInEarn = /Log\s+in\s+to\s+earn\s+([\d,]+)\s+(?:Cash\s+)?(?:Points\s+)?on\s+purchase\.?/i;

  const getSmileRoots = (container = document) => {
    const roots = new Set();
    container.querySelectorAll(`.${targetClass}`).forEach(el => roots.add(el));
    container.querySelectorAll('[id*="smile"] , [class*="smile"], [id*="Smile"]').forEach(el => roots.add(el));
    container.querySelectorAll('smile-points-product, [data-smile], .smile-points-on-product-page').forEach(el => roots.add(el));
    if (roots.size === 0) roots.add(container.body || container);
    return roots;
  };

  const replaceTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      if (searchPattern.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(searchPattern, replacementText);
      }
      node = walker.nextNode();
    }
  };

  const replaceInTargets = (container = document) => {
    if (!isRtl()) return;
    getSmileRoots(container).forEach((target) => replaceTextNodes(target));
  };

  const translateRewardLineToArabic = (container = document) => {
    if (!isRtl()) return;
    getSmileRoots(container).forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        const text = node.nodeValue || '';
        const earnMatch = text.match(earnWithCash) || text.match(earnPlain);
        if (earnMatch && earnMatch[1]) {
          node.nodeValue = `اكسب ${earnMatch[1]} نقطة نقدية عند شراء هذا المنتج`;
        } else {
          const loginMatch = text.match(logInEarn);
          if (loginMatch && loginMatch[1]) {
            node.nodeValue = `سجل دخولك لتكسب ${loginMatch[1]} نقطة نقدية عند الشراء`;
          }
        }
        node = walker.nextNode();
      }
    });
  };

  /**
   * RTL: Smile.io often replaces [points_amount] only in LTR/English. Copy the points value
   * from a populated block (e.g. "Earn 50 when...") into any element that still has [points_amount].
   */
  const replacePointsAmountInRtl = () => {
    if (document.documentElement.getAttribute('dir') !== 'rtl') return;

    const pointsAmountPlaceholder = /\[points_amount\]/g;
    const pointsValuePattern = /Earn\s+(\d+)\s+(?:points?\s+)?when|(\d+)\s+points?\s+when/i;

    const findPointsValue = () => {
      const byDataAttr = document.querySelector('[data-points-amount], [data-points], [data-smile-points]');
      if (byDataAttr) {
        const v = byDataAttr.getAttribute('data-points-amount') || byDataAttr.getAttribute('data-points') || byDataAttr.getAttribute('data-smile-points');
        if (v && /^\d+$/.test(v)) return v;
      }
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        const text = node.nodeValue || '';
        const match = text.match(pointsValuePattern);
        if (match) {
          const value = match[1] || match[2];
          if (value) return value;
        }
        node = walker.nextNode();
      }
      return null;
    };

    const run = () => {
      const value = findPointsValue();
      if (!value) return;
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        if (pointsAmountPlaceholder.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(pointsAmountPlaceholder, value);
        }
        node = walker.nextNode();
      }
    };

    run();
    setTimeout(run, 1500);
    setTimeout(run, 3500);
  };

  const runRtlRewardTranslation = () => {
    replaceInTargets();
    replacePointsAmountInRtl();
    translateRewardLineToArabic();
  };

  const handleDomReady = () => {
    runRtlRewardTranslation();
    setTimeout(runRtlRewardTranslation, 800);
    setTimeout(runRtlRewardTranslation, 2000);

    const observer = new MutationObserver(() => {
      if (document.documentElement.getAttribute('dir') === 'rtl') {
        replaceInTargets();
        translateRewardLineToArabic();
      }
      replacePointsAmountInRtl();
      translateRewardLineToArabic();
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleDomReady);
  } else {
    handleDomReady();
  }
})();
